import { issueTypeFromCategory } from '../../model/issue-type';

/**
 * Issue search: case-insensitive substring over the bug title, the test id
 * and the issue-type label ("environment" finds Environment issues). Same
 * shape as Instances/search.ts; lists are tiny so filtering is instant
 * (the TMS Issues tab has no debounce either).
 */
export function issueMatches(item, query) {
  var q = query.trim().toLowerCase();
  if (q === '') return true;
  if (item.title.toLowerCase().includes(q)) return true;
  if (item.testId.toLowerCase().includes(q)) return true;
  return issueTypeFromCategory(item.category).label.toLowerCase().includes(q);
}